<ng-container
  *ngFor="let categoryDetail of categoryDetails; index as categoryDetailsIndex"
>
  <my-bill-odb-category-details-identifier
    [validFor]="categoryDetail.validFor"
    [category]="category"
  ></my-bill-odb-category-details-identifier>
  <my-bill-odb-category-sections
    [billingAccountNumber]="billingAccountNumber"
    [documentReference]="documentReference"
    [category]="category"
    [sections]="categoryDetail.sections"
    [productSplitIdentifier]="productSplitIdentifier"
    [categoryDetailValidFor]="categoryDetail.validFor"
  ></my-bill-odb-category-sections>
</ng-container>
